import { Form, Row, Col, Select, Button, message, FormInstance, Divider, Space, Tooltip } from 'antd'
import React, { useEffect, useState } from 'react'
import { requestBlockingIssues } from '../../../utils/tableColumns';
import helper from '../../../utils/helper';
import { getBlockingIssuesApi, getBlockingIssuesTypesApi, updateAdvanceIssueApi } from '../../../utils/apisConsts';
import { OutPutResult, ReusableDataTable, TruckingModal as Modal } from '@operations/shared';
import { errorMessage } from '../../../utils/commonStringsConsts';
import { Region } from '../../../utils/commonInterfaces';
import { getRegion } from '../../../components/regionWrapper';

export default function GetBlockingIssues() {
    const region = getRegion();
    const formFilterRef = React.createRef<FormInstance>();
    const [filterForm] = Form.useForm();
    const [issuesTypes, setIssuesTypes] = useState([]);
    const [issues, setIssues] = useState([]);
    const [typeHasBug, setTypeHasBug] = useState(false);
    const [paginating, setPaginating] = useState({
        pageSize: 10,
        total: 0,
        current: 1,
    });
    const [filter, setFilter] = useState({
        issueType: region === Region.SE ? [] : '',
    });
    const issueTypeSelection = Form.useWatch('issueType', filterForm) || [];
    const hasIssueSelection = Array.isArray(issueTypeSelection) && issueTypeSelection.length > 0;
    const hasAppliedFilters = Array.isArray(filter.issueType) && filter.issueType.length > 0;
    const [issuesLoading, setIssuesLoader] = useState(false);
    const [errorMode, setErrorMode] = useState(false);
    const [clear, setClear] = useState(false);
    const [modal, setModal] = useState(false);
    const [issueID, setIssueID] = useState(0);
    const [btnLoader, setBtnLoader] = useState(false);
    const [viewPagination, setViewPagination] = useState(true);
    const [resolveText, setResolveText] = useState('')
    useEffect(() => {
        storeBlockingIssuesTypes();
        storeBlockingIssues();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const storeBlockingIssuesTypes = async () => {
        try {
            const apiData: any = await helper.callApiRequest(getBlockingIssuesTypesApi, 'GET');
            const resp = apiData.data;
            if (resp.status === 200) {
                setIssuesTypes(resp.data.issueTypes);
                return
            }
            message.error(resp.message, 4)
            setTypeHasBug(true);
        } catch (error: any) {
            message.error(error.data.message, 4)
            setTypeHasBug(true);
        }
    }

    const storeBlockingIssues = async (allParams?: any) => {
        setIssuesLoader(true);
        try {
            const params = {
                count: allParams?.pageSize ? allParams?.pageSize : paginating.pageSize,
                page: allParams?.current ? allParams?.current : paginating.current,
                [region === Region.SE ? 'issueTypeIDs' : 'issueType']:
                    region === Region.SE ? (Array.isArray(allParams?.issuetypeIDs) ? allParams.issuetypeIDs.join(",") : "")
                    : allParams?.issueType ? allParams.issueType : '',
            }
            const apiData: any = await helper.callApiRequest(getBlockingIssuesApi, 'GET', params);
            const resp = apiData.data;
            if (resp.status === 200) {
                await setPaginating((prevState: any) => ({
                    ...prevState,
                    total: resp?.totalOFBlockingIssues,
                }))
                allParams?.issueType ? setClear(true) : setClear(false);
                const manipulateTheData = Array.isArray(resp.data) && resp.data.map((issue: any) => {
                    return {
                        ...issue,
                        createdAt: issue?.createdAt ? helper.changeDateFormat(issue?.createdAt) : 'NA',
                        requestedAmount: issue?.requestedAmount ? helper.amountFormatter(issue?.requestedAmount) + (region === Region.SE ? ' SAR' : ' EGP') : 'NA',
                        userBalance: issue.userBalance ? helper.amountFormatter(issue.userBalance) + (region === Region.SE ? ' SAR' : ' EGP') : 'NA'
                    }
                });

                setIssues(manipulateTheData);
                setIssuesLoader(false);
                setViewPagination(true);
                return
            }
            if (resp.status === 404) {
                setIssuesLoader(false);
                setIssues([]);
                setViewPagination(false);
                allParams?.issueType ? setClear(true) : setClear(false);
                return
            }

            setIssuesLoader(false);
            setErrorMode(true);
        } catch (error: any) {
            setIssuesLoader(false);
            setErrorMode(true);
        }
    }
    const selectAllIssueTypes = () => {
        if (!Array.isArray(issuesTypes) || !issuesTypes.length) {
            filterForm?.setFieldsValue({ issueType: [] });
            return;
        }
        const allIssueTypeIds = issuesTypes?.map((issue: any) => issue?.id);
        filterForm?.setFieldsValue({ issueType: allIssueTypeIds });
    }
    const unselectAllIssueTypes = () => {
        filterForm?.setFieldsValue({ issueType: [] });
    }
    const changePagination = async (values: any) => {
        setPaginating((prevState: any) => ({
            ...prevState,
            current: values?.current,
            pageSize: values?.pageSize
        }))
        const allParams = {
            current: values?.current,
            pageSize: values?.pageSize,
            issueType: filter.issueType,

        }
        await storeBlockingIssues(allParams);
    }
    const filterBlockingIssues = async (values: any) => {
        setFilter(
            region === Region.SE ?
                { issueType: Array.isArray(values.issueType) ? values.issueType : [] } 
                : { ...filter, ...(values.issueType ? { issueType: values.issueType } : { issueType: '' })}
        )
        setPaginating((prevState: any) => ({
            ...prevState,
            current: 1,
        }))
        const allParams = {
            pageSize: paginating.pageSize,
            total: paginating.total,
            current: 1,
            [region === Region.SE ? 'issuetypeIDs' : 'issueType']: values.issueType,
        }
        await storeBlockingIssues(allParams);
    }
    const clearIssueTypeFilters = async () => {
        const currentSelection = issueTypeSelection;
        if (!Array.isArray(currentSelection) || issuesLoading) {
            return;
        }
        const basePageSize = paginating.pageSize;
        setFilter({
            issueType: [],
        });
        setPaginating((prevState: any) => ({
            ...prevState,
            current: 1,
        }));
        filterForm.setFieldsValue({ issueType: [] });
        const allParams = {
            pageSize: basePageSize,
            current: 1,
            issuetypeIDs: [],
        };
        await storeBlockingIssues(allParams);
    }
        const clearsIssuesFilter = () => {
        setFilter((prevState: any) => ({
            ...prevState,
            issueType: '',
        }));
        setPaginating((prevState: any) => ({
            ...prevState,
            current: 1,
        }))
        const allParams = {
            pageSize: 10,
            total: paginating.total,
            current: 1,
            issueType: '',
        }
        formFilterRef.current!.resetFields();
        storeBlockingIssues(allParams);
    }
    const selectingAnIssue = (issueID: number, isResolved: boolean) => {
        setModal(true)
        setResolveText(isResolved ? 'Un-resolved' : 'Resolve')
        setIssueID(issueID)
    }
    const closeTheModal = () => {
        setModal(false)
    }
    const resolveRequestIssue = async () => {
        try {
            setBtnLoader(true)
            const bodyData = {
                issueID: issueID
            }
            const apiData: any = await helper.callApiRequest(updateAdvanceIssueApi, 'PATCH', {}, bodyData);
            const resp = apiData.data;
            if (resp.status === 200) {
                setBtnLoader(false);
                setModal(false);
                message.success(resp.message);
                const allParams = {
                    pageSize: paginating.pageSize,
                    total: paginating.total,
                    issueType: filter.issueType,
                }
                await storeBlockingIssues(allParams);
                return
            }
            message.error(resp.message);
            setBtnLoader(false);
            setModal(false);
        } catch (error) {
            console.log("🚀 ~ file: getIssues.tsx:153 ~ resolveRequestIssue ~ error:", error)
            setBtnLoader(false);
            message.error(errorMessage)
        }
    }
    const resolveAction = {
        title: 'Resolve',
        render: (record: { manualResolve: boolean, issueID: number, isResolved: boolean }) => (
            <>
                <Button style={record.isResolved ? { borderColor: '#6fb76c', color: '#6fb76c', width: '114px' } : { color: '#40a9ff', borderColor: '#40a9ff', }}
                    disabled={!record.manualResolve}
                    onClick={() => selectingAnIssue(record.issueID, record.isResolved)} type={"ghost"} >{record.isResolved ? 'Resolved' : 'Resolve Issue'}</Button>
            </>
        )
    };
    const columns = [...requestBlockingIssues, resolveAction];
    const content = <>
        <div className='resolveIssue'>

            <p className='question' style={{ textAlign: 'center', fontSize: '16px', fontWeight: 600 }}>Are you sure you want to {resolveText} this issue?</p>

            <Row style={{ margin: '20px 0' }}>
                <Col span={24}>
                    <Button className='decline' onClick={closeTheModal}>No </Button>
                    <Button className='approve' onClick={resolveRequestIssue} loading={btnLoader}>Yes</Button>
                </Col>

            </Row>

        </div>
    </>
    return (
        <>
            {errorMode ?
                <OutPutResult status={'500'} title={'Oops!'} subTitle={'Something went wrong, please refresh and try again'} /> :
                <>
                    {region === Region.SE ?
                        <div
                            className="filterTransaction"
                            style={{
                                backgroundColor: '#ffffff',
                                border: '1px solid #f0f3ff',
                                borderRadius: 14,
                                padding: '16px 22px',
                                marginBottom: 24,
                                boxShadow: '0 6px 18px rgba(35, 64, 120, 0.04)',
                            }}
                        >
                            <Form
                                form={filterForm}
                                name="blockingIssuesFilters"
                                initialValues={{ issueType: [] }}
                                onFinish={filterBlockingIssues}
                                autoComplete="off"
                            >
                                <Row gutter={[24, 12]} align="middle">
                                    <Col span={16}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                            <span style={{ fontSize: 13, fontWeight: 600, color: '#4a5a80', letterSpacing: 0.3 }}>
                                                Issue Types
                                            </span>
                                            <Form.Item name="issueType" style={{ marginBottom: 0, flex: 1 }}>
                                                <Select
                                                    mode="multiple"
                                                    style={{ width: "100%" }}
                                                    placeholder="Select an issue type"
                                                    disabled={typeHasBug}
                                                    dropdownRender={(menu) => {
                                                        const hasSelection = hasIssueSelection;
                                                        const hasIssueTypes = Array.isArray(issuesTypes) && issuesTypes?.length > 0;
                                                        return (
                                                            <>
                                                                <div
                                                                    style={{
                                                                        display: 'flex',
                                                                        justifyContent: 'flex-start',
                                                                        padding: '8px 12px',
                                                                        margin: '8px',
                                                                        borderRadius: 8,
                                                                        backgroundColor: '#f8fbff',
                                                                        border: '1px solid #f0f5ff',
                                                                    }}
                                                                >
                                                                    <Space size={10}>
                                                                        <Tooltip title="Select all issue types">
                                                                            <Button
                                                                                size="small"
                                                                                type="default"
                                                                                style={{
                                                                                    border: '1px solid #d9e2ff',
                                                                                    backgroundColor: '#f4f7ff',
                                                                                    color: '#4154d0',
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center',
                                                                                    padding: '0 12px',
                                                                                    minWidth: 108,
                                                                                    height: 32,
                                                                                }}
                                                                                aria-label="Select all issue types"
                                                                                onMouseDown={(event) => {
                                                                                    event.preventDefault();
                                                                                    event.stopPropagation();
                                                                                    selectAllIssueTypes();
                                                                                }}
                                                                                disabled={typeHasBug || !hasIssueTypes}
                                                                            >
                                                                                <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                                                                    <i className="fas fa-check-double" style={{ fontSize: 12 }} aria-hidden="true" />
                                                                                    <span style={{ fontSize: 12, fontWeight: 600, color: '#1d39c4' }}>Select All</span>
                                                                                </span>
                                                                            </Button>
                                                                        </Tooltip>
                                                                        <Tooltip title="Unselect all issue types">
                                                                            <Button
                                                                                size="small"
                                                                                type="default"
                                                                                style={{
                                                                                    border: '1px solid #ffe1d9',
                                                                                    color: '#b54730',
                                                                                    backgroundColor: '#fff7f4',
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center',
                                                                                    padding: '0 12px',
                                                                                    minWidth: 108,
                                                                                    height: 32,
                                                                                }}
                                                                                aria-label="Unselect all issue types"
                                                                                onMouseDown={(event) => {
                                                                                    event.preventDefault();
                                                                                    event.stopPropagation();
                                                                                    unselectAllIssueTypes();
                                                                                }}
                                                                                disabled={typeHasBug || !hasSelection}
                                                                            >
                                                                                <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                                                                    <i className="fas fa-undo-alt" style={{ fontSize: 12 }} aria-hidden="true" />
                                                                                    <span style={{ fontSize: 12, fontWeight: 600, color: '#b54730' }}>Unselect All</span>
                                                                                </span>
                                                                            </Button>
                                                                        </Tooltip>
                                                                    </Space>
                                                                </div>
                                                                <Divider style={{ margin: '0' }} />
                                                                {menu}
                                                            </>
                                                        )
                                                    }}
                                                >
                                                    {Array.isArray(issuesTypes) &&
                                                        issuesTypes?.map((issue: any) => (
                                                            <Select.Option key={issue?.id} value={issue?.id}>
                                                                {issue?.name}
                                                            </Select.Option>
                                                        ))}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item style={{ marginBottom: 0 }}>
                                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
                                                {hasAppliedFilters && (
                                                    <Button
                                                        onClick={clearIssueTypeFilters}
                                                        type="default"
                                                        disabled={issuesLoading}
                                                        style={{
                                                            borderColor: '#ffe7ba',
                                                            color: '#b37403',
                                                            backgroundColor: '#fff9eb',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: 6,
                                                            padding: '0 14px',
                                                            height: 36,
                                                            fontWeight: 600,
                                                        }}
                                                    >
                                                        <i className="fas fa-broom" style={{ fontSize: 12 }} aria-hidden="true" />
                                                        Clear Filters
                                                    </Button>
                                                )}
                                                <Button
                                                    type="primary"
                                                    htmlType="submit"
                                                    style={{
                                                        backgroundColor: '#4c6ef5',
                                                        borderColor: '#4c6ef5',
                                                        boxShadow: '0 6px 16px rgba(76, 110, 245, 0.18)',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 8,
                                                        padding: '0 18px',
                                                        height: 36,
                                                        fontWeight: 600,
                                                        opacity: !hasIssueSelection || issuesLoading ? 0.55 : 1,
                                                        cursor: !hasIssueSelection || issuesLoading ? 'not-allowed' : 'pointer',
                                                    }}
                                                    disabled={!hasIssueSelection || issuesLoading}
                                                >
                                                    <i className="fas fa-search" style={{ fontSize: 13 }} aria-hidden="true" />
                                                    Search
                                                </Button>
                                            </div>
                                        </Form.Item></Col>
                                </Row>
                            </Form>
                        </div> :
                        <div className="filterTransaction">
                        <Form
                            ref={formFilterRef}
                            name="basic"
                            initialValues={{ remember: true }}
                            onFinish={filterBlockingIssues}
                            autoComplete="off"
                        >
                            <Row className=''>


                                <Col span={12} style={{ padding: '0 10px 0 0' }}>
                                    <label htmlFor="">Issue Types </label>
                                    <Form.Item name="issueType">
                                        <Select style={{ width: "100%" }} placeholder="Select an issue type" disabled={typeHasBug}>
                                            {
                                                Array.isArray(issuesTypes) &&
                                                issuesTypes.map((issue: any) => <Select.Option value={issue.id}>{issue.name}</Select.Option>)
                                            }
                                        </Select>
                                    </Form.Item>
                                </Col>
                                {true && <Col span={4} style={{ float: 'right' }}>
                                    <Form.Item>

                                    </Form.Item></Col>}

                                <Col span={6}>
                                    <Form.Item>
                                        <div style={{ display: 'flex', padding: '20px 0' }}>
                                            {clear && <Button type="primary" onClick={clearsIssuesFilter} style={{ width: '150px', background: '#d01a1a', borderColor: '#d01a1a' }}>
                                                Clear
                                            </Button>}
                                            <Button type="primary" htmlType="submit" style={{ width: '150px', margin: ' 0 0 0 15px' }}>
                                                Search
                                            </Button>
                                        </div>
                                    </Form.Item></Col>


                            </Row>
                        </Form>
                    </div>}
                    <ReusableDataTable rows={issues} columns={columns} handleTableChange={changePagination}
                        pagination={viewPagination ? paginating : false} loading={issuesLoading} scrolling={{ x: 'max-content' }} hiddenRefreshing />
                    <Modal handleCloseModal={closeTheModal} visibleModal={modal} content={content} title={'Resolve issue'} />
                </>
            }
        </>
    )
}
